import React, { useEffect } from "react";
import "./nujobsMyEvals.scss";
import NuJobsMyEvalsCard from "../nujobsMyEvalsCard";
import useNuJobsStore from "../../../store/nujobsevals.store";

function NuJobsMyEvals() {
  const { getMyEvals, myEvals } = useNuJobsStore();

  useEffect(() => {
    getMyEvals();
  }, []);

  return (
    <>
      <div> NuJobsMyEvals</div>
      <div className="nujobs-my-evals-cards-container1">
        {myEvals?.map((evalItem) => (
          <NuJobsMyEvalsCard evalItem={evalItem} />
        ))}
      </div>
    </>
  );
}

export default NuJobsMyEvals;
